import FAQBase from "./FAQBase"

const HouseKeeperFAQs = () => {
  return <FAQBase title="HouseKeeper FAQs" faqType="HouseKeeper" />
}

export default HouseKeeperFAQs
